export const SUPPORT_EMAIL = 'help@deepsource.io'
